export const environment = {
	production: true,
	couchDB: {
		userDB: 'https://admin:e2rXeHeKbSbM@couchdb.go-suite.com',
		agentDB: 'https://admin:e2rXeHeKbSbM@couchdb-agent.go-suite.com',
	},
	xena: {
		autocomplete: {
			endpoint: 'https://api.go-suite.com/xena-autocomplete/v1/'
		},
		rentalCar: {
			token: 'm0spW3QzMbph8hqL5Y6J'
		},
		formButler: {
			token: ']X<KG5_tpc+;3!wz3E',
		},
	},
	bedsAndMore: {
		autocomplete: {
			endpoint: 'https://api.go-suite.com/bam-autocomplete/v1/'
		},
	},
	url: 'https://office.go-suite.com',
	title: 'GO Suite'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts